import BaseOrganizationController from "@rmp/core/api/base/baseOrganizationController";
import AbortService from "@rmp/core/services/abortService";

export class DivisionsController extends BaseOrganizationController {
	constructor(abortService: AbortService) {
		super(abortService);
	}
	
	getDivisions = this.api.public.organizationalStructureList;

	/** Возвращает серверную область доступа сотрудника без раскрытия подразделений по дереву. */
	getDivisionAccess = this.api.division.accessList;
}
